import React, { createContext, useEffect, useRef, useState } from 'react'

import { loginCustomer, getCustomerData, registerCustomer, updateCustomer, resetPasswordEmail, getShippingAddress,updateAccountPassword, addShippingAddress, removeShippingAddress, editShippingAddress, updateDefaultShippingAddress, getCustomerOrders, activateAccount } from "@utils";

import { mockOrderHistory } from '@mockdata/mockdata'
import { getTimeRemaining } from '@utils/utils'

const UserContext = createContext({
  user: '',
  openNavBar: false,
  setOpenNavBar: () => {},
  openUserAccountMenu: false,
  setOpenUserAccountMenu: () => {},
})
 
export const UserProvider = ({ children }) => {
    const menuButtonRef = useRef(null)

    const [openLoginModal, setOpenLoginModal] = useState(false)
	const [forceShowRegister, setForceShowRegister] = useState(false)
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [loginSuccess, setLoginSuccess] = useState(false)
    const [newlyRegistered, setNewlyRegistered] = useState(false)
	const [openNavBar, setOpenNavBar] = useState(false)
    const [openUserAccountMenu, setOpenUserAccountMenu] = useState(false)
    const [user, setUser] = useState([])
    const [isLoadingUser, setIsLoadingUser] = useState(true);
    
    const [orderHistoryData] = useState(mockOrderHistory)
    const [viewOrderData, setViewOrderData] = useState([])

    const [defaultShippingAddress, setDefaultShippingAddress] = useState([])
    const [shippingAddress, setShippingAddress] = useState([])
    const [mockBBBucks, setMockBBBucks] = useState(1500)
    const [customerOrders, setCustomerOrders] = useState([])
    const [token, setToken] = useState(() => {
        if (typeof window === "undefined") return "";
        return localStorage.getItem("shopifyToken") || "";
    });
	const countdownHeaderTargetDate = "2026-04-01T07:00:00Z"
	const countdownHeaderTimeRemaining = getTimeRemaining(countdownHeaderTargetDate)
	
    const [visitorWishlist, setVisitorWishlist] = useState(() => {
		if (typeof window !== "undefined") {
			const stored = localStorage.getItem('visitor-wishlist')
			if (stored) {
				try {
					const parsed = JSON.parse(stored)
					return parsed?.visitorWishlist || []
				} catch (e) {
					console.error("Failed to parse wishlist:", e)
				}
			}
		}
		return []
	})

	useEffect(() => {
        if (typeof window !== "undefined") {
		    localStorage.setItem('visitor-wishlist', JSON.stringify({ visitorWishlist }))
        }
	}, [visitorWishlist])

    useEffect(() => {
        const getCX = async () => {
            setIsLoadingUser(true);
    
            try {
                const data = await getCustomerData(token);
                if (data?.data?.customer) {
                    setUser(data.data.customer);
                    setIsLoggedIn(true);
                }
            } catch (error) {
                console.error("Error fetching customer data:", error);
            } finally {
                setIsLoadingUser(false);
            }
        };
    
        if (token) {
            getCX();
        } else {
            setIsLoadingUser(false);
        }
   
    }, [token]);

	const showRegisterFormModal = () => {
		setForceShowRegister(true)
	}

	useEffect(() => {
		if(forceShowRegister) {
			setOpenLoginModal(true)
		}
	}, [forceShowRegister])


    const register = async (firstName, lastName, email, password) => {
        return await registerCustomer(firstName, lastName, email, password);
    };

    const login = async (email, password) => {
        const res = await loginCustomer(email, password);
        
        if (res?.errors?.length > 0) {
            return res;
        } else {

            if (res.data.customerAccessTokenCreate.customerAccessToken) {
                const accessToken = res.data.customerAccessTokenCreate.customerAccessToken.accessToken;
                setToken(accessToken);
                localStorage.setItem("shopifyToken", accessToken);
                const userData = await getCustomerData(accessToken).then((data) => setUser(data.data.customer));
                console.log(userData)
                
                return true;
            } else {
                return res;
            }
        }        
    };

    useEffect(() => {
        if (user?.id) {
            localStorage.setItem("userId", user.id);
        } else {
            localStorage.removeItem("userId");
        }

        const syncWishlist = async () => {
            if (!user?.id) return;

            try {
                const res = await fetch("/bb-wishlist", {
                    method: "GET",
                    headers: { "x-user-id": user.id },
                });

                const dbWishlist = await res.json();
                const dbProducts = dbWishlist?.[0]?.products
                    ? JSON.parse(dbWishlist[0].products)
                    : [];

                const combined = [...visitorWishlist, ...dbProducts];

                const merged = combined.filter(
                    (item, index, self) =>
                        index === self.findIndex((i) => i.handle === item.handle)
                );

                const hasChanges =
                    merged.length !== dbProducts.length ||
                    merged.some((item, i) => item.handle !== dbProducts[i]?.handle);

                if (hasChanges) {
                    await fetch("/bb-wishlist", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "x-user-id": user.id,
                        },
                        body: JSON.stringify(merged),
                    });
                }

                setVisitorWishlist(merged);
            } catch (err) {
                console.error("Wishlist sync failed:", err);
            }
        };

        syncWishlist();
    }, [user])


    const fetchCustomerOrders = async () => {
        const res = await getCustomerOrders(token);

        if (res?.data?.errors?.length > 0) {
            return res;
        } else {
            if (res?.data?.customer?.orders) {
                setCustomerOrders(res?.data?.customer?.orders?.edges)
                return true;
            } else {
                return res;
            }
        }
    };

    const fetchShippingAddress = async () => {
        const res = await getShippingAddress(token);

        if (res?.data?.errors?.length > 0) {
            return res;
        } else {
            if (res?.data?.customer?.addresses) {
                setShippingAddress(res?.data?.customer?.addresses?.edges)
                setDefaultShippingAddress(res?.data?.customer?.defaultAddress?.id)
                return true;
            } else {
                return res;
            }
        }
    };


    const createShippingAddress = async (address1, address2, city, province, country, zip, phone, company) => {
        const res = await addShippingAddress(token, address1, address2, city, province, country, zip, phone, company);


        if (res?.data?.errors?.length > 0) {
            return res;
        } else {
            if (res?.data?.customerAddressCreate?.customerAddress) {
                return await fetchShippingAddress();
                //setShippingAddress(res?.data?.customer?.addresses?.edges)
            } else {
                return res;
            }
        }
    }

    const updateShippingAddress = async (addressId, address1, address2, city, province, country, zip, phone, company) => {
        const res = await editShippingAddress(token, addressId, address1, address2, city, province, country, zip, phone, company);


        if (res?.data?.errors?.length > 0) {
            return res;
        } else {
            if (res?.data?.customerAddressUpdate?.customerAddress) {
                return await fetchShippingAddress();
            } else {
                return res;
            }
        }
    }

    const updateDefaultShipping = async (addressId) => {
        const res = await updateDefaultShippingAddress(token, addressId);


        if (res?.data?.errors?.length > 0) {
            return res;
        } else {
            if (res?.data?.customerDefaultAddressUpdate?.customer?.defaultAddress) {
                return await fetchShippingAddress();
            } else {
                return res;
            }
        }
    }

    const activateUserAccount = async (customerId, activationToken, password) => {
        const res = await activateAccount(customerId, activationToken, password);
        return res;
    }


    const deleteShippingAddress = async (addressId) => {
        const res = await removeShippingAddress(token, addressId);

        if (res?.data?.errors?.length > 0) {
            return res;
        } else {
            if (res?.data?.customerAddressDelete?.deletedCustomerAddressId) {
                return true;
            } else {
                return res;
            }
        }
    }

    const updateAccount = async (firstName, lastName, phone) => {
        const res = await updateCustomer(token, firstName, lastName, phone);
        
        if (res?.errors?.length > 0) {
            return res;
        } else {
            if (res.data.customerUpdate.customer) {
                setUser(res.data.customerUpdate.customer);
                return true;
            } else {
                return res;
            }
        }
    };

    
    const resetPassword = async (email) => {
        const res = await resetPasswordEmail(email);

        if (res?.errors?.length > 0) {
            return res;
        } else {
            if (res?.data?.customerRecover?.customerUserErrors?.length === 0) {
                return true;
            } else {
                return res;
            }
        }
    }

    const updatePassword = async (customerId, resetToken, password) => {
        const res = await updateAccountPassword(customerId, resetToken, password);
        return res;
    }

    const handleLoginSuccess = (value) => {
        setLoginSuccess(value)
        setIsLoggedIn(value)
    }

    const handleSignOut = () => {
        localStorage.removeItem("shopifyToken");
        setUser([]);
        setToken("");

        setNewlyRegistered(false)
        setLoginSuccess(false)
        setIsLoggedIn(false)
    }

    const adjustBBBucks = (value) => {
        setMockBBBucks(mockBBBucks + value)
    }

	const visitorAddToWishlist = async (item) => {
		// console.info("added to wishlist:",item)
		setVisitorWishlist(prev => [...prev, item])

        if (user?.id) {
            await fetch("/bb-wishlist", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-user-id": user.id,
                },
                body: JSON.stringify(visitorWishlist),
            });
        }
	}

	const visitorRemoveFromWishlist = (item) => {
		setVisitorWishlist(prev => {
			const newWishlist = [...prev]
			const index = newWishlist.findIndex(
                ws => ws?.variants?.[0]?.id === item?.variants?.[0]?.id
            );
			if(index !== -1) newWishlist.splice(index, 1)
			
			return newWishlist
		})
	}

    return (
        <UserContext.Provider
        value={{
            menuButtonRef,
            isLoggedIn,
            setIsLoggedIn,
            user,
            setUser,
            openLoginModal,
            setOpenLoginModal,
            loginSuccess,
            setLoginSuccess,
            newlyRegistered,
            setNewlyRegistered,
			openNavBar,
			setOpenNavBar,
            openUserAccountMenu,
			setOpenUserAccountMenu,
            handleLoginSuccess,
			countdownHeaderTargetDate,
			countdownHeaderTimeRemaining,
            
            orderHistoryData,
            viewOrderData,
            setViewOrderData,
            shippingAddress,
            
            removeShippingAddress,
            mockBBBucks,
            adjustBBBucks,
            token,
            register,
            login,
            updateAccount,
            handleSignOut,
            fetchShippingAddress,
            createShippingAddress,
            deleteShippingAddress,
            updateShippingAddress,
            defaultShippingAddress,
            setDefaultShippingAddress,
            updateDefaultShipping,
            isLoadingUser,
            fetchCustomerOrders,
            customerOrders,
            resetPassword,
            updatePassword,
            activateUserAccount,
			forceShowRegister,
			setForceShowRegister,
			showRegisterFormModal,
			visitorWishlist,
			visitorAddToWishlist,
			visitorRemoveFromWishlist,
        }}
        >
        {children}
        </UserContext.Provider>
    );
}

export default UserContext